/**
 * TOAST-UX-001 — TitleFlow global toast policy (wraps the real `sonner` package; see craco alias `sonner$`).
 * Auto-dismiss defaults when a call site passes no explicit `duration`:
 *   success / info / message / default → 2 s · warning → 4.5 s · error → 8 s (X always dismisses immediately)
 * Explicit `duration` in a call is respected, so existing business logic is unchanged.
 */
import { toast as base, Toaster, useSonner } from 'sonner-original';

export const TOAST_DURATIONS = { default: 2000, success: 2000, info: 2000, message: 2000, warning: 4500, error: 8000 };

const withDuration = (kind, opts) => (opts && opts.duration !== undefined ? opts : { ...(opts || {}), duration: TOAST_DURATIONS[kind] });

const toast = (message, opts) => base(message, withDuration('default', opts));
toast.success = (message, opts) => base.success(message, withDuration('success', opts));
toast.info = (message, opts) => base.info(message, withDuration('info', opts));
toast.message = (message, opts) => base.message(message, withDuration('message', opts));
toast.warning = (message, opts) => base.warning(message, withDuration('warning', opts));
toast.error = (message, opts) => base.error(message, withDuration('error', opts));
// pass-throughs (loading stays until resolved/dismissed; custom/promise keep their own semantics)
toast.loading = base.loading;
toast.custom = base.custom;
toast.promise = base.promise;
toast.dismiss = base.dismiss;
toast.getHistory = base.getHistory;
toast.getToasts = base.getToasts;

export { toast, Toaster, useSonner };
